import api from '@/api/index.js'

const municipality_bot_clients = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_MUNICIPALITY_BOT_CLIENTS_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_MUNICIPALITY_BOT_CLIENTS: (state, response) => {
      state.data = response
      state.loading = false
    },
    SET_MUNICIPALITY_BOT_CLIENTS_ERROR: (state, error) => {
      state.error = error
    },
  },

  actions: {
    GetMunicipalityBotClients({commit}, query) {
      commit('SET_MUNICIPALITY_BOT_CLIENTS', [])
      commit('SET_MUNICIPALITY_BOT_CLIENTS_ERROR', null)
      commit('SET_MUNICIPALITY_BOT_CLIENTS_LOADING', true)
      return api.get(`municipalities/${query.municipalityId}/bot-clients`)
        .then((response) => {
          commit('SET_MUNICIPALITY_BOT_CLIENTS', response)
        })
        .catch((error) => {
          commit('SET_MUNICIPALITY_BOT_CLIENTS_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_MUNICIPALITY_BOT_CLIENTS_LOADING', false)
        })
    },
  }
}

export default municipality_bot_clients
